<template>
  <div class="export-contacts">
    <div class="nav-bar row">
      <div class="nav-title col large-12">
        <div class="pointer" @click="() => goBack()">
          &lt; {{ $t('back') }}
        </div>
        <label class="summary-hello emphasis">{{ $t("hamburgerMenu.exportContacts") }}</label>
      </div>
      <div class="nav-btns col large-12">
        <HKLButton
          v-if="routerViewRef"
          color="orange"
          :action="exportBtn.actionTitle"
          @click="() => exportBtn.func()"
        />
      </div>
    </div>
    <div class="pages-settings-container">
      <div class="tab-container row">
        <div class="col large-12 font-bold">
          {{ $t('exportContacts.listTitle') }}
        </div>
        <div class="col small-7 medium-4 large-2">
          <HKLSelect
            v-model="selectedRoute"
            :options="routeOpts"
            @select="val => navTo(val)"
          />
        </div>
      </div>
      <router-view
        ref="routerViewRef"
      />
    </div>
  </div>
</template>

<script>
import { computed, unref, ref, onMounted } from 'vue-demi'
import HKLSelect from '@/controls/Select/HKLSelect.vue'
import engineerRouter from '@/router/paths/engineers'
import { ExportContactsRouteNames } from '@/constants/router'
import i18n from '@/utils/i18n'
import nav, { goBack } from '@/utils/navigation'
import useRouter from '@/router/useRouter'
import HKLButton from '@/controls/Button/HKLButton.vue'
import { aclHelper } from '@/utils/aclHelper'

export default {
  components: {
    HKLButton,
    HKLSelect,
  },
  setup () {
    const routePaths = computed(() => {
      return engineerRouter.paths.routes.find(r => r.name === ExportContactsRouteNames.exportContacts).children.filter(r => {
        const permTypes = r.meta.acl.permTypes
        if (!permTypes || !Array.isArray(permTypes) || permTypes.length === 0) {
          return false
        }
        const allowed = permTypes.some((permType) => {
          const granted = aclHelper.getAccess(permType)
          return granted
        })
        return allowed
      })
    })
    const routeOpts = computed(() => {
      return unref(routePaths).map(p => {
        return { value: p.name, name: i18n.t(`exportContacts.${p.name}`) }
      })
    })
    const selectedRoute = ref('')
    const routerViewRef = ref(null)
    const { route } = useRouter()
    onMounted(() => {
      const curRouteName = unref(route).name
      if (unref(routePaths).some(r => r.name === curRouteName)) {
        selectedRoute.value = curRouteName
      }
    })
    const exportBtn = computed(() => {
      if (!routerViewRef.value || !routerViewRef.value.exportBtn || typeof routerViewRef.value.exportBtn.func !== 'function') {
        return {}
      }
      return routerViewRef.value.exportBtn
    })
    return {
      routerViewRef,
      exportBtn,
      selectedRoute,
      routePaths,
      routeOpts,
      navTo: nav.toPage,
      goBack: () => {
        selectedRoute.value = ''
        goBack()
      },
    }
  },
}
</script>

<style scoped lang="scss">
@import "~styles/dashboard/style.scss";
@import "~styles/settings/style.scss";

.tab-container {
  padding: 15px 24px;
}
.pages-settings-container {
  margin: 0 auto;
}
.nav-btns {
  text-align: right;
}
</style>
